import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Auth, Usergroup } from 'services/action';
import _ from 'underscore';
import * as Fi from 'react-icons/fi';
import { SkeletonTable } from 'ui/components/skeleton';

const initialState = {
  show: false,
  detail: null,
  module: null,
};

const TableAccess = ({ data }) => {
  const Dispatch = useDispatch();
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Usergroup.Show']
  );

  const [{ show, detail, module }, setState] = React.useState(initialState);

  const $clearState = () => {
    setState({ ...initialState });
  };

  const $onLoad = async (id) => {
    const req = await Dispatch(Usergroup.$show(id));

    if (req?.message === 'success') {
      setState((prevState) => ({ ...prevState, detail: req?.data }));
      $getAuth(req?.data?.privileges);
    }
  };

  const $getAuth = async (p) => {
    const req = await Dispatch(Auth.$authorization());
    let selected = await p?.map((d) => d);

    const data = await req?.data?.map((g) => ({
      ...g,
      is_checked: selected?.includes(g?.id),
    }));

    const e = _.filter(data, function (o) {
      return o?.is_checked;
    });

    let m = await e?.map((d) => d?.module);

    const hasData = _.filter(data, function (f) {
      return m?.includes(f?.module);
    });

    let x = _.groupBy(hasData, 'module');

    setState((prevState) => ({ ...prevState, module: x }));
  };

  React.useEffect(() => {
    if (!show) return;
    $onLoad(data?.id);
  }, [show]);

  return (
    <div>
      <div
        className="btn btn-primary fs-7 py-1"
        onClick={() => setState((prevState) => ({ ...prevState, show: true }))}
      >
        <div>Lihat Hak Akses</div>
      </div>

      <Modal
        show={show}
        onHide={$clearState}
        backdrop="static"
        centered
        scrollable
        size="lg"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Hak Akses {detail?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-1 p-md-3">
          {StateLoading ? (
            <SkeletonTable headerCount={4} bodyCount={9} />
          ) : (
            <div
              className={'mx-1 border-start border-end border-top rounded-2'}
            >
              <div className="row py-3 bg-light m-0 fw-semibold border-bottom">
                <div className="col-1 text-center">No</div>
                <div className="col-5 col-md-6">Module</div>
                <div className="col-6 col-md-5">
                  <div className="row">
                    <div className="col-6 text-center"> Read Only </div>
                    <div className="col-6 text-center"> Manage </div>
                  </div>
                </div>
              </div>
              {module &&
                Object?.entries(module)
                  .sort()
                  .map(
                    ([key, value], k) =>
                      key !== 'booking' &&
                      key !== 'vehicle' &&
                      key !== 'job' && (
                        <div key={key}>
                          <div className="row py-2 m-0 border-bottom align-items-center">
                            <div className="col-1 text-center">{k + 1}</div>
                            <div className="col-5 col-md-6 ">
                              <div className="text-capitalize my-1">
                                {key?.replace('location', 'lokasi')}
                              </div>
                            </div>
                            <div className="col-6 col-md-5 ">
                              <div className="row align-items-center">
                                {value
                                  ?.sort(function (a, b) {
                                    if (a.action < b.action) return 1;
                                    if (a.action > b.action) return -1;
                                    return 0;
                                  })
                                  .map((el, k) => (
                                    <div key={k} className="col-6 text-center ">
                                      <div className="text-capitalize">
                                        {el?.is_checked ? (
                                          <Fi.FiCheckSquare
                                            size="18"
                                            color="green"
                                          />
                                        ) : null}
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                  )}
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default TableAccess;
